module.exports = __webpack_public_path__ + "img/gold_prime@2x.33139a32.png";